<template>
<div>
  <div class="text-center">
    <button class="btn btn-outline-primary btn-sm mt-4" data-bs-toggle="collapse" href="#goalHistory" role="button" aria-expanded="false" aria-controls="goalHistory">Toggle Goal History</button>
  </div>
  <div class="collapse mt-2" id="goalHistory">
    <div class="card card-body shadow-md">
      <ag-table :columnDefs="table.columnDefs" :rowData="learnerGoalsStore.state.learnerGoalsHistory"></ag-table>
    </div>
  </div>
</div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api';
import AgTable from '@/modules/ees/components/AgTable.vue';
import { LearnerGoalsStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';

export default defineComponent({
  name: 'GoalHistory',
  components: {
    AgTable
  },
  setup(){
    const learnerGoalsStore = injectStrict(LearnerGoalsStoreKey);
    learnerGoalsStore.actions.getGoalsHistory();

    const table = reactive({ 
      columnDefs: [
        { 
          headerName: 'Goal', 
          field: 'title',
          flex: 1 
        },
        { 
          headerName: 'Completed Date', 
          field: 'statusChangeDate',
          type: ['dateColumn'] 
        }
      ]
    });

    return {
      table,
      learnerGoalsStore
    }
  }
})
</script>